import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, switchMap, startWith } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApikeyActions } from './apikey.actions';
import { ApiKeyService } from '../../api-services/apikey.service';
import { AppActions } from '../app/app.actions';

@Injectable()
export class ApikeyEffects {
  private actions$ = inject(Actions)

  constructor(
    private apikeyService: ApiKeyService,
  ) { }

  loadApikeys$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApikeyActions.loadApikeys),
      concatMap(() =>
        this.apikeyService.getApikeys().pipe(
          switchMap(data => [
            ApikeyActions.loadApikeysSuccess({ data }),
            AppActions.setLoading({ loading: false })
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  createApikeys$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApikeyActions.createApikey),
      concatMap((payload) =>
        this.apikeyService.createApikey(payload.name).pipe(
          switchMap(data => [
            ApikeyActions.createApikeySuccess({ data }),
            AppActions.setLoading({ loading: false }),
            ApikeyActions.loadApikeys()
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  revokeApikeys$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApikeyActions.revokeApikey),
      concatMap((payload) =>
        this.apikeyService.revokeApiKey(payload.id).pipe(
          switchMap(data => [
            ApikeyActions.revokeApikeySuccess({ data }),
            AppActions.setLoading({ loading: false }),
            ApikeyActions.loadApikeys()
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

}
